<div class="w-full h-full flex flex-col gap-2 overflow-y-auto">
    <div class="w-full flex flex-col items-center justify-center gap-2">
        <h2 class="w-full oswald-font text-2xl">
            Teacher/Staff Interview
        </h2>
        <!-- <p class="w-full">
            For use when interviewing staff members who witnessed or have direct knowledge about the threatening situation, and/or who have specific knowledge regarding the student or the threatening situation being reviewed. These questions provide a foundation for the interview, but may be modified or expanded as necessary depending on the circumstances.
        </p> -->
    </div>

    <div class="h-full w-full overflow-y-auto flex flex-col items-start justify-start gap-4">
        <ol class="flex h-14 shrink-0 items-center w-full">
            <li *ngFor="let step of stepsConfig" class="flex w-full items-center after:content-[''] after:w-full after:h-1 after:border-b after:border-gray-100 after:border-4 after:inline-block">
                <button 
                    [attr.data-tooltip-target]="step.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === step.id,
                        'bg-orange-100': currentStep !== step.id && currentTeacherStaffInterview?.[step.completionProperty] === 1,
                        'bg-gray-100': currentStep !== step.id && currentTeacherStaffInterview?.[step.completionProperty] !== 1,
                        'cursor-not-allowed': step.nextStepDependency && currentTeacherStaffInterview?.[step.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(step.id)"
                    [disabled]="step.nextStepDependency && currentTeacherStaffInterview?.[step.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileUser" [ngClass]="{
                        'text-white': currentStep === step.id,
                        'text-nside-orange-400': currentStep !== step.id && currentTeacherStaffInterview?.[step.completionProperty] === 1,
                        'text-gray-text': currentStep !== step.id && currentTeacherStaffInterview?.[step.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="step.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[step.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
            <li class="flex items-center">
                <button 
                    [attr.data-tooltip-target]="finalStepConfig.completionProperty" data-tooltip-placement="bottom"
                    class="flex items-center justify-center w-10 h-10 rounded-full shrink-0"
                    [ngClass]="{
                        'bg-nside-orange-400': currentStep === finalStepConfig.id,
                        'bg-orange-100': currentStep !== finalStepConfig.id && currentTeacherStaffInterview?.[finalStepConfig.completionProperty] === 1,
                        'bg-gray-100': currentStep !== finalStepConfig.id && currentTeacherStaffInterview?.[finalStepConfig.completionProperty] !== 1,
                        'cursor-not-allowed': finalStepConfig.nextStepDependency && currentTeacherStaffInterview?.[finalStepConfig.nextStepDependency] !== 1
                    }"
                    (click)="goToStep(finalStepConfig.id)"
                    [disabled]="currentTeacherStaffInterview?.[finalStepConfig.nextStepDependency] !== 1"
                >
                    <lucide-icon [img]="icons.FileCheck" [ngClass]="{
                        'text-white': currentStep === finalStepConfig.id,
                        'text-nside-orange-400': currentStep !== finalStepConfig.id && currentTeacherStaffInterview?.[finalStepConfig.completionProperty] === 1,
                        'text-gray-text': currentStep !== finalStepConfig.id && currentTeacherStaffInterview?.[finalStepConfig.completionProperty] !== 1
                    }"></lucide-icon>
                </button>
                <div [id]="finalStepConfig.completionProperty" role="tooltip" class="absolute z-30 invisible inline-block px-3 py-2 text-sm font-medium text-white bg-gray-600 rounded-lg shadow-sm opacity-0 tooltip">
                    {{ tooltips[finalStepConfig.id-1]}}
                    <div class="tooltip-arrow" data-popper-arrow></div>
                </div>
            </li>
        </ol>
        <div class="w-full flex flex-col items-center justify-center overflow-y-auto gap-2">
            <staff-info 
                *ngIf="this.currentStep===1 && this.currentTeacherStaffInterview"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection1)="handleUpdateTeacherStaffInterview($event, 1)"
            ></staff-info>
            <threat-knowledge 
                *ngIf="this.currentStep===2"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection2)="handleUpdateTeacherStaffInterview($event, 2)"
            ></threat-knowledge>
            <academics 
                *ngIf="this.currentStep===3"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection3)="handleUpdateTeacherStaffInterview($event, 3)"
            ></academics>
            <behavior 
                *ngIf="this.currentStep===4"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection4)="handleUpdateTeacherStaffInterview($event, 4)"
            ></behavior>
            <teacher-peer-relationship 
                *ngIf="this.currentStep===5"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection5)="handleUpdateTeacherStaffInterview($event, 5)"
            ></teacher-peer-relationship>
            <depression 
                *ngIf="this.currentStep===6"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection6)="handleUpdateTeacherStaffInterview($event, 6)"
            ></depression>
            <aggression 
                *ngIf="this.currentStep===7"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection7)="handleUpdateTeacherStaffInterview($event, 7)"
            ></aggression>
            <parent-contact 
                *ngIf="this.currentStep===8"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection8)="handleUpdateTeacherStaffInterview($event, 8)"
            ></parent-contact>
            <summary 
                *ngIf="this.currentStep===9"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview" 
                (onSaveSection9)="handleUpdateTeacherStaffInterview($event, 9)"
            ></summary>
            <teacher-staff-interview-submission 
                *ngIf="this.currentStep===10"
                class="w-full h-full overflow-y-auto"
                [teacherStaffInterviewData]="this.currentTeacherStaffInterview"
                (onSaveSection10)="handleUpdateTeacherStaffInterview($event, 10)"
            ></teacher-staff-interview-submission>
        </div>
    </div>
</div>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>